<template>
  <div class="m-pc-title">
    <div class="title" :title="title">
      {{ title }}
    </div>
    <div class="sub-title">
      <div class="date">
        {{ createTime }}
      </div>
      <div class="statistics">
        <span class="icontemp chakan"></span> <span>{{ browseCount }}</span>
        <span class="icontemp dianzan" v-if="isAllowedLike"></span>
        <span v-if="isAllowedLike">{{ likeCount }}</span>
        <span class="icontemp xiaoxi" v-if="isAllowedComment"></span>
        <span v-if="isAllowedComment">{{ commentCount }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Title",
  data() {
    return {
      title: "",
      createTime: "",
      likeCount: "",
      browseCount: "",
      commentCount: "",
      isAllowedComment: "",
      isAllowedLike: false
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        this.title = info.title;
        this.createTime = info.createTime;
        this.likeCount = info.likeCount;
        this.browseCount = info.statInfo.browseCount;
        this.isAllowedComment = info.isAllowedComment == 1;
        this.isAllowedLike = info.isAllowedLike == 1;
      }
    });
    $subscriber.subscribe("comment-count", info => {
      this.commentCount = info;
    });
    $subscriber.subscribe("like-count", info => {
      this.likeCount = info;
    });
  },
  components: {}
};
</script>
